import { z } from 'zod';

/**
 * 클라이언트 환경 변수 스키마.
 *
 * Vite는 `VITE_` 접두사가 붙은 변수만 클라이언트 번들에 노출한다.
 * 이 스키마를 통해 빌드 타임에 환경 변수의 존재/형식을 검증해
 * 런타임에 `undefined`로 인한 장애를 막는다.
 */
const envSchema = z.object({
  /** 코드 검증 API 베이스 URL. (예: `https://api.darakcast.example.com`) */
  VITE_API_BASE_URL: z.string().url(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('[env] 환경 변수 검증 실패:', parsed.error.flatten().fieldErrors);
  throw new Error(
    '환경 변수가 누락되었거나 형식이 잘못되었습니다. `.env.example`을 참고하세요.',
  );
}

/**
 * 검증된 환경 변수. 앱 어디서든 `env.VITE_API_BASE_URL` 형태로 접근한다.
 */
export const env = parsed.data;
